<div *ngIf="isLoading" nz-row class="cards-container" [nzGutter]="[20, 20]">
  <nz-col
    *ngFor="let i of pageSizeArray"
    nzXs="24"
    nzSm="24"
    nzMd="12"
    nzLg="8"
    nzXl="6"
  >
    <nz-card-loading> </nz-card-loading>
  </nz-col>
</div>
<ng-container *ngIf="!isLoading">
  <nz-empty
    nzNotFoundImage="simple"
    *ngIf="!isLoading && listOfRecords.table.rowsArray.length === 0"
  >
  </nz-empty>

  <div class="board-columns" cdkDropListGroup>
    <div class="column-title">
      {{ listOfRecords.table.rowsArray[0]['StepLast'] }}
    </div>
    <nz-col   nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
      <nz-row class="tasks-container" cdkDropList cdkDropListOrientation="vertical"
      [cdkDropListData]="listOfRecords.table.rowsArray"
      (cdkDropListDropped)="drop($event)">

        <nz-card class="task" *ngFor="let record of listOfRecords.table.rowsArray" style="width: 100%;" cdkDrag nzHoverable >
          <div class="selected-flag" >
            <i nz-icon nzType="check" nzTheme="outline"></i>
          </div>
          <div [innerHtml]="getRecordHtml(record) | safeHtml"></div>
        </nz-card>

      </nz-row>
    </nz-col>
</div>
  <!-- ////////// -->

  <div class="root">
    <div class="navbar has-background-dark">
      <div class="navbar-brand">
        <div class="navbar-item">
          <h1 class="app-name has-gradient-text">kanban</h1>
        </div>
      </div>
    </div>

    <div class="board">
      <div class="board-bar">
        <p class="board-name">{{ board.name }}</p>
      </div>

      <div class="board-wrapper">
        <div class="board-columns" cdkDropListGroup>
          <div class="board-column" *ngFor="let column of board.columns">
            <div class="column-title">
              {{ column.Name }}
            </div>

            <div
              class="tasks-container"
              cdkDropList
              [cdkDropListData]="column.Cards"
              (cdkDropListDropped)="drop($event)"
            >
              <!-- <div class="task" cdkDrag *ngFor="let item of column.Cards" [innerHTML]="getRecordHtml(item)" >
              </div> -->
              <nz-card class="task" *ngFor="let item of column.Cards" style="width: 100%;" cdkDrag nzHoverable >
                <div class="selected-flag" >
                  <i nz-icon nzType="check" nzTheme="outline"></i>
                </div>
                <div [innerHtml]="getRecordHtml(item) | safeHtml"></div>
              </nz-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
